import React from "react"
import { isBrowserHandledClick } from "../clickEvents"
import { createRouteForData, RouteItemData } from "../route"
import { withRouter } from "../router"

export type LinkProps = {
    to: RouteItemData | string
    title?: string
    "data-button-type"?: string
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

export const Link = withRouter((router) => ({ to, title, children, ...rest }: LinkProps): JSX.Element => {
    const href = typeof to === "string" ? to : createRouteForData(router.origin, router.routes, to).url

    const handleClick = (ev: React.MouseEvent) => {
        // Action Item 6751: modified clicks (ctrl/cmd/shift), middle click, or already-handled
        // events keep the browser's native behavior (e.g. open in new tab) - only plain left
        // clicks are intercepted for SPA navigation.
        if (isBrowserHandledClick(ev)) return
        ev.preventDefault()
        router.navigate(to)
    }

    return (
        <a {...rest} href={href} onClick={rest.onClick || handleClick} title={title}>
            {children}
        </a>
    )
})
